import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "@environments/environment";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { ParamsService } from "@shared/Services/params.service";

import { Dropdown } from "@salud/shared/Types/dropdown.enum";
import { OptionsType } from "@salud/shared/Types/options-type.interface";

import { HistoricoCarnet, HistoricoCarnetEmail, HistoricoCarnetFilter } from "../Types/interfaces/HistoricoCarnet.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class HistoricoCarnetRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getHistoricoCarnets(filter: HistoricoCarnetFilter): Observable<HistoricoCarnet[]> {
    const params = this.paramsService.mapRequestParams({
      ...filter,
      identificationType: filter.tipoIdentificacion,
      identification: filter.numeroIdentificacion,
      contractNumber: filter.numeroContrato,
    });
    return this.http.get<HistoricoCarnet[]>(`${enlineaBackendUrl}/api/ars/cards/historical`, { params }).pipe(
      map((getCarnet) => {
        return getCarnet.map((carnet) => ({
          ...carnet,
          dependentFullName: `${carnet.dependentFirstName} ${carnet.dependentLastName}`,
          ownerFullName: `${carnet.ownerFirstName} ${carnet.ownerLastName}`,
          historical: carnet.historical.map((history) => {
            return {
              ...history,
              dependentFullName: `${history.dependentFirstName} ${history.dependentLastName}`,
            };
          }),
        }));
      })
    );
  }

  public getPlanes(): Observable<OptionsType<string, string>[]> {
    return this.http.get<OptionsType<string, string>[]>(`${enlineaBackendUrl}/api/Comunes/DropDown/${Dropdown.Producto}`);
  }

  public printCarnet(identificationNumber: string, contractNumber: string): Observable<Blob> {
    const params = this.paramsService.mapRequestParams({ identificationNumber, contractNumber });
    return this.http.get<Blob>(`${enlineaBackendUrl}/api/DigitalCards/report`, {
      params,
      responseType: "blob" as "json",
    });
  }

  public sendEmailNotification(request: HistoricoCarnetEmail): Observable<ShareMessageResponse> {
    return this.http.post<ShareMessageResponse>(`${enlineaBackendUrl}/api/ars/DigitalCards/email`, request);
  }
}
